const getSynceeNavigation = (t, { isAdmin = false } = {}) => [
  { to: "/dropshipping/platforms", label: t("h_syncee_nav_all", "Platforms") },
  { to: "/dropshipping/syncee", label: t("h_syncee_nav_syncee", "Syncee") },
  { to: "/dropshipping/syncee/connect", label: t("h_syncee_nav_connect", "Connection") },
  { to: "/dropshipping/syncee/suppliers", label: t("h_syncee_nav_suppliers", "Suppliers") },
  { to: "/dropshipping/syncee/products", label: t("h_syncee_nav_products", "Products") },
  { to: "/dropshipping/syncee/imported", label: t("h_syncee_nav_imported", "Imported") },
  { to: "/dropshipping/syncee/orders", label: t("h_syncee_nav_orders", "Orders") },
  { to: "/dropshipping/syncee/errors", label: t("h_syncee_nav_errors", "API Errors") },
  ...(isAdmin ? [{ to: "/dropshipping/syncee/admin", label: t("h_syncee_nav_admin", "Administration") }] : []),
];
module.exports = { getSynceeNavigation };
